module.exports = __webpack_public_path__ + "static/blog32-b2071dd8c831554857045cb037cd7a3a.png";